import { CommonModule, DatePipe, Location } from '@angular/common';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterModule } from '@angular/router';
import { EvaluationService } from 'src/app/shared/services/evaluationservice/evaluation.service';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { Component, OnInit, HostListener } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import Swal from 'sweetalert2';
import { Chart } from 'chart.js';
import { NavigateEvaluationService } from 'src/app/navigate-evaluation.service';
import { LoaderComponent } from "src/app/shared/components/loader/loader.component";
import { ModalModule } from "ngx-bootstrap/modal";
import { CarouselModule } from 'ngx-bootstrap/carousel';

@Component({
  selector: 'app-user-evaluation',
  // standalone: true,
  templateUrl: './user-evaluation.component.html',
  styleUrl: './user-evaluation.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule, ModalModule, CarouselModule],
  providers: [DatePipe],

})
export class UserEvaluationComponent implements OnInit {
  public showSpinner = true;
  evaluations: any[] = [];
  date = new Date();
  model: any = {};
  id: any
  user: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  firstName: any;
  lastName: any;
  kpValuesAndDescription: any;
  yearlyAveragePoints: any;
  monthlyAveragePoints: any;
  wariningPercentage: any;
  data: any;
  item: any;
  showPoints: any;
  constructor(private router: Router,
    private location: Location,
    private navigationEvaluationService: NavigateEvaluationService,
    private evaluationService: EvaluationService,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
    private datePipe: DatePipe,
    private route: ActivatedRoute) {



    this.route.queryParams.subscribe(params => {
      this.id = params['id'];
      this.firstName = params['first_name'];
      this.lastName = params['last_name'];
    });
    this.data = JSON.parse(this.route.snapshot.queryParams.data);
    this.model = {
      month_int: this.date.getMonth() + 1,
      month_char: this.datePipe.transform(this.date.setMonth(this.date.getMonth()), "MMMM"),
      month_year: this.date.getFullYear(),
    }
    this.user = JSON.parse(localStorage.getItem('user') || '');

    const user_role = JSON.parse(this.user.user_role.user_roles)
    //  if(user_role.role_type == "Admin_AND_Team_Lead"){
    //   this.router.navigate(['/evaluation-yearly']);
    //  }else if(user_role.role_type != "Admin"){
    //     this.router.navigate(['/user-dashboard']);
    //   }



    this.user_detail();

  }
  // @HostListener('window:popstate', ['$event'])
  // onPopState() {
  //   // this.router.navigate(['/evaluation-list']);
  //   this.location.back();
  // }
  ngOnInit(): void {
    this.getAllEvaluationByAdmin(this.id);
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
    this.getEvaluation();


  }

  navigateBack(): void {
    // Navigate back to the stored route
    this.router.navigateByUrl(this.navigationEvaluationService.previousRoute);
  }
  isavailablefeature(type: string): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles);
    if (user_role.role_type == "Team_Lead") {
      return true
    } else {
      switch (type) {
        case "add":
          return !user_role.team_evaluation.data.values.add === false
        case "update":
          return !user_role.team_evaluation.data.values.update === false
        default:
          return false;
      }
    }
  }



  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }
  onReset(form: NgForm) {
    form.reset();
    this.getAllEvaluationByAdmin(this.id);
  }
  getColorPoint(data: any) {
    if (data <= 3) {
      return '#FED7DA';
    }
    if (data > 3 && data <= 4) {
      return '#DAD4FF';
    }
    if (data > 4 && data <= 5) {
      return '#FFE9B2';
    }
    if (data > 5 && data < 9) {
      return '#B9D6FF';
    }
    if (data >= 9) {
      return '#84FF89';
    }
    return '';
  }
  getBackgroundPoint(data: any) {
    if (data <= 3) {
      return '#FFF4F5';
    }
    if (data > 3 && data <= 4) {
      return '#dad4ff';
    }
    if (data > 4 && data <= 5) {
      return '#faedcd';
    }
    if (data > 5 && data < 9) {
      return '#DBEAFF';
    }
    if (data >= 9) {
      return '#E2FFE3';
    }
    return '';
  }
  getBorderPoint(data: any) {
    if (data <= 3) {
      return '#FD7171';
    }
    if (data > 3 && data <= 4) {
      return '#6358A7';
    }

    if (data > 4 && data <= 5) {
      return '#FFB700';
    }
    if (data > 5 && data < 9) {
      return '#2180FF';
    }
    if (data >= 9) {
      return '#007505';
    }
    return '';
  }

  getPointRemarks(data: any) {
    if (data <= 3) {
      return 'Poor';
    }
    if (data > 3 && data <= 4) {
      return 'Below';
    }
    if (data > 4 && data <= 5) {
      return 'Normal';
    }
    if (data > 5 && data < 9) {
      return 'Good';
    }
    if (data >= 9) {
      return 'Excellent';
    }
    return '';
  }
  onSubmit(form: NgForm) {
    const formData = form.value;
    const date = new Date(formData.date);
    this.model = {
      month_int: date.getMonth() + 1,
      month_char: this.datePipe.transform(date, "MMMM"),
      month_year: date.getFullYear()
    };

    this.getAllEvaluationByAdmin(this.id);
  }

  addEvaluation(evaluation: any) {
    this.router.navigate(['/evaluation-add'], {
      queryParams: {
        evaluation: JSON.stringify(evaluation),
        data: JSON.stringify(this.data)
      },
      skipLocationChange: true,
    });
  }
  getid(id: any) {
    this.router.navigate(['/update-evaluation'], {
      queryParams: {
        id: id,
        data: JSON.stringify(this.data)
      },
      skipLocationChange: true,
    });
  }
  getAllEvaluationByAdmin(id: any) {
    this.showSpinner = true
    this.evaluationService.getUserEvaluation(id).then((value: any) => {

      if (value.success) {
        this.showSpinner = false
        this.evaluations = value.data.evaluations;
        this.evaluations
        const points: any[] = [];
        let totalEntries = 0;
        let warnings = 0;
        this.evaluations.forEach((x: any) => {
          if (x.pm_points < 5) {
            warnings++;
          }
          totalEntries++;
          points.push(x.pm_points);
        });
        const percentageone = (points.reduce((partial_sum, a) => partial_sum + a, 0) / totalEntries) * 10;

        const roundedValue = Math.round(percentageone);

        this.yearlyAveragePoints = isNaN(roundedValue) ? 'Average' : roundedValue;

        const percentage = (this.evaluations[this.evaluations.length - 1]?.pm_points / 10) * 100;
        this.monthlyAveragePoints = Math.round(percentage);
        this.showPoints = this.monthlyAveragePoints / 10;
        const percentagetwo = (warnings / totalEntries) * 100
        this.wariningPercentage = Math.round(percentagetwo);
        const colors = [
          '#FFB700',
          '#28a745',
          '#333333',
          '#c3e6cb',
          '#dc3545',
          '#6c757d',
        ];

        /* large line chart */
        const chLine = document.getElementById('chLine');
        const chartData = {
          labels: ['Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'],
          datasets: [
            {
              data: points,
              backgroundColor: '#FFE9B2',
              borderColor: colors[0],
              borderWidth: 4,
              pointBackgroundColor: colors[0],
              fill: true
            },
          ],
        };

        if (chLine) {
          new Chart('chLine', {
            type: 'line',
            data: chartData,
            options: {
              maintainAspectRatio: false,
              scales: {
                yAxes: [
                  {
                    display: false,
                    ticks: {
                      min: 1,
                      max: 10,
                      stepSize: 1,
                      beginAtZero: false,
                    },
                  },
                ],
                xAxes: [
                  {
                    ticks: {
                      min: 1,
                      max: 10,
                      stepSize: 1,
                      beginAtZero: false,
                    },
                  },
                ],
              },

              legend: {
                display: false,
              },
            },
          });

          this.evaluations.forEach((data: any) => {
            if (data != null) {
              data.percentage = data.points + "/10";
              const bandPercentage = (data.points / 10) * 100;
              data.bands = bandPercentage <= 25 ? 1 : bandPercentage > 25 && bandPercentage <= 50 ? 2
                : bandPercentage > 50 && bandPercentage <= 75 ? 3 : 4
            }
          });
        }

      }
    });

  }
  showdata(data: any) {

    // this.router.navigate(['/evaluation-summary']
    this.router.navigate(['/add-evaluation']

      , {
        queryParams: { data: JSON.stringify(data), kpValues: JSON.stringify(this.kpValuesAndDescription) },
        skipLocationChange: true,
      });
  }

  getEvaluation() {
    this.evaluationService.getEvaluation().then((value) => {
      this.showSpinner = false;
      // this.evaluations = value.data.evaluations;
      // this.showdata(this.evaluations[0])
      this.kpValuesAndDescription = value.data.kps_list;

    });
  }

}
